import React from "react";
import TabNavigation from "./TabNavigation";
import TabsContainer from "./TabsContainer";
import "./Tabs.css";

class Tabs extends React.Component {
  state = { activeTab: 0 };

  onHandleTabClick = (id) => {
    this.setState({
      activeTab: id,
    });
  };

  render() {
    return (
      <div className="tabs">
        <TabNavigation
          tabsNavArray={this.props.tabsNavArray}
          activeTab={this.state.activeTab}
          onHandleTabClick={this.onHandleTabClick}
        />
        <TabsContainer activeTab={this.state.activeTab}>
          {this.props.children}
        </TabsContainer>
      </div>
    );
  }
}

export default Tabs;
